module.exports = __webpack_public_path__ + "static/img/cardbg5.d1a1493.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardbg5.png
// module id = 9P9Y
// module chunks = 1